var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { attrs: { dense: "", nav: "" } },
    _vm._l(_vm.items, function(item) {
      return _c(
        "v-list-item",
        { key: item.title },
        [
          _c(
            "v-list-item-icon",
            [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              { attrs: { depressed: "" } },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(" " + _vm._s(item.title) + " ")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              ),
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { attrs: { color: "blue lighten-4" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "text-h5",
                        attrs: { color: "blue lighten-4" }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("global.profile.change.password")) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "password",
                                      label: _vm.$t(
                                        "global.profile.change.password.new"
                                      ),
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.password,
                                      callback: function($$v) {
                                        _vm.password = $$v
                                      },
                                      expression: "password"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "password",
                                      label: _vm.$t(
                                        "global.profile.change.password.confirm"
                                      ),
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.passwordConfirm,
                                      callback: function($$v) {
                                        _vm.passwordConfirm = $$v
                                      },
                                      expression: "passwordConfirm"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: {
                            click: function($event) {
                              return _vm.changePassword()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.confirm")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red darken-1", text: "" },
                          on: {
                            click: function($event) {
                              return _vm.close()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }